const institucionalUrl = 'https://facilitajuridico.com.br/';
const institucionalPricesUrl = `${institucionalUrl}prices`;
const apiUrl = (process.env.REACT_APP_API_URL || 'https://api.facilitajuridico.com').replace(/\/$/, '');
const whatsappSupport = process.env.REACT_APP_WHATSAPP_SUPPORT || '5515997400433';
const whatsappSupportUrl = `${apiUrl}/marketing/whatsapp/support-contact/redirect`;
const faciliterSupportEmail = 'contato@facilitajuridico.com';
const faciliterSupportUrl = `mailto:${faciliterSupportEmail}`;
const orbitaAppUrl = (process.env.REACT_APP_ORBITA_APP_URL || 'https://orbita.facilitajuridico.com').replace(/\/$/, '');
const orbitaTicketsUrl = `${orbitaAppUrl}/tickets`;
const orbitaProfileUrl = `${orbitaAppUrl}/profile`;
const orbitaSupportChatUrl = (process.env.REACT_APP_ORBITA_SUPPORT_CHAT_URL || `${orbitaAppUrl}/embed/support`).replace(/\/$/, '');
const publicAssetsBaseUrl = `${apiUrl}/files/assets`;
const appAssetsBucket = 'facilita-app';

const encodeObjectKey = (objectKey) => objectKey.split('/').map(encodeURIComponent).join('/');
const publicAssetUrl = (bucket, objectKey) => `${publicAssetsBaseUrl}/${bucket}/${encodeObjectKey(objectKey)}`;
const appAssetUrl = (objectKey) => publicAssetUrl(appAssetsBucket, objectKey);

function formatPhoneDisplay(full) {
    const digits = full.replace(/\D/g, '');
    const national = digits.startsWith('55') ? digits.slice(2) : digits;
    const ddd = national.slice(0, 2);
    const number = national.slice(2);
    return `(${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`;
}

const whatsappSupportDisplay = formatPhoneDisplay(whatsappSupport);

export const appConstants = {
    institucionalUrl,
    institucionalPricesUrl,
    whatsappSupport,
    whatsappSupportUrl,
    whatsappSupportDisplay,
    faciliterSupportEmail,
    faciliterSupportUrl,
    orbitaTicketsUrl,
    orbitaProfileUrl,
    orbitaSupportChatUrl,
    publicAssetUrl,
    appAssetUrl,
}
